// CARO. Casa de estilo — route params as LOGICAL (Spanish) values.
//
// EN/FR routes match translated URLs (`/fr/boutique/:category` for
// `/shop/:category`), so useParams() would hand a page the public value
// (`maison`). Pages call this hook with their logical pattern instead: it
// matches that pattern against the logical path of the current location, so
// `category` is `casa` (and, once articles get per-locale slugs, `slug` is the
// Spanish one) in every locale.

import { matchPath, useLocation, type Params } from 'react-router';
import { toLogicalPath } from '@/lib/seo';
import { INITIAL_LOCALE } from '@/client/i18n/locale';

/** Params of logical `pattern` (e.g. `/shop/:category/:slug`) for the current URL; {} if it doesn't match. */
export function useLogicalParams<K extends string>(pattern: string): Params<K> {
  // useLocation's pathname is already relative to the basename (no /fr prefix).
  const { pathname } = useLocation();
  return matchPath(pattern, toLogicalPath(INITIAL_LOCALE, pathname))?.params ?? {};
}
